/** Mensaje genérico mostrado cuando falla el inicio/cierre de sesión (FR-006). */
export const ACCOUNT_ACTION_ERROR_MESSAGE = 'No se ha podido completar la operación. Inténtalo de nuevo.'

export const ACCOUNT_ACTION_INITIAL_STATE = { status: 'idle', errorMessage: null } as const

/** Nombre accesible del spinner mientras se redirige al login/logout. */
export const ACCOUNT_ACTION_LOADING_LABEL = 'Redirigiendo a tu cuenta'
